import { requestGet, requestPost, requestGetFilterEmpty } from '@/common/request';
import env from '@/env';
export default {
  // 综促 正向卡片列表
  async zongcuRelationList(data) {
    return await requestGetFilterEmpty('/zongcu/relationList', data);
  },
  // 创建综促活动的类型 权限按钮
  async zongcuCanBeCreated(query) {
    return await requestGet('/zongcu/canBeCreated', query);
  },
  // 创建综促之后自动关联
  async zongcuRelation(query) {
    return await requestGet('/zongcu/relation', query);
  },
  async zongcuParticipatedRelationList(query) {
    return await requestGet('/zongcu/participatedRelationList', query);
  },
  async zongcuExport(query) {
    return await requestGet('/zongcu/export', query);
  },
  // 我的创建 综促列表
  async zongcuMylist(query) {
    return await requestGetFilterEmpty('/zongcu/myList', query);
  },
  async zongcuMyManagerList(query) {
    return await requestGet('/zongcu/myManagerList', query);
  },
  async BannerListByPlanCode(query) {
    return await requestGet('/banner/listByPlanCode', query);
  },
  // 模版详情配置查询接口 https://joyspace.jd.com/pages/Jag3iUxegb1FmbPHCzYb
  async getTemplateSchema(templateId) {
    return await requestGet(`${env.MAC_DOMAIN}/layout/template/schema/${templateId}`);
  },
};
